import { lazy } from 'react';

export default {
  exact: false,
  name: 'GIMAC Cardless ATM',
  protected: true,
  path: '/gimac-cardless-atm',
  component: lazy(() => import('containers/Gimac/cardlessAtm')),
};
